/**
 * Storage thuần cho snapshot filter của list page — KHÔNG import React/Redux.
 *
 * Tách riêng khỏi `useFilterPersistence` để `authSlice` dùng được mà không tạo vòng
 * import (authSlice -> useFilterPersistence -> useAuth -> authSlice).
 *
 * Vì sao localStorage (giữ qua F5 / đóng-mở tab) nhưng lại XOÁ KHI LOGOUT, khác với
 * `erp_col_*` của useColumnSettings vốn giữ vĩnh viễn: cột chỉ chứa preference giao
 * diện, còn filter chứa `search` — nhân viên gõ SĐT/tên khách vào đó. Máy POS ở cửa
 * hàng xoay ca dùng chung nên dữ liệu khách không được nằm lại vô thời hạn trên đĩa.
 * Ranh giới phiên đăng nhập là vòng đời đúng cho nó.
 */
export const FILTER_STORAGE_PREFIX = 'erp_filter_';

/** Table state lưu kèm filter: vào detail rồi quay ra mà mất trang / pageSize là
 *  phần lớn cảm giác "mất filter" của người dùng. */
export const FILTER_TABLE_STATE_KEYS = ['page', 'pageSize', 'sortField', 'sortOrder'] as const;

/**
 * Scope theo userId để hai người dùng chung một máy không thấy điều kiện lọc của nhau.
 *
 * KHÔNG thêm tenantId vào key: một user chỉ thuộc một tenant (`AuthUser.tenantId` là
 * singular) nên userId đã đủ tách. Lấy tenantId sẽ phải gọi useAuth trong
 * useFilterPersistence, kéo Redux vào một hook thuần storage và làm vỡ mọi test
 * render list page mà không bọc <Provider>.
 */
export function buildFilterStorageKey(tableKey: string, userId?: string): string {
  return `${FILTER_STORAGE_PREFIX}${userId ?? 'default'}_${tableKey}`;
}

/** Gọi khi kết thúc phiên đăng nhập (logout / token hết hạn / 401 refresh fail). */
export function clearAllFilterSnapshots(): void {
  try {
    const doomed: string[] = [];
    for (let i = 0; i < localStorage.length; i += 1) {
      const key = localStorage.key(i);
      if (key?.startsWith(FILTER_STORAGE_PREFIX)) doomed.push(key);
    }
    doomed.forEach((key) => localStorage.removeItem(key));
  } catch {
    // localStorage unavailable (SSR / private mode)
  }
}
